export default __webpack_public_path__ + "static/media/white_chevron_down.55851347.svg";